export default "__VITE_ASSET__DQkgjwM2__"